module.exports = __webpack_public_path__ + "static/assets/16c364516f24ec3735be710a8e3836ae.svg";